import React from "react";
import { createPortal } from "react-dom";

type ModalOverlayProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
  className?: string;
};

/**
 * Full-viewport modal backdrop. Portals to document.body so layout
 * overflow/transform on <main> does not clip fixed overlays.
 */
export function ModalOverlay({
  children,
  className = "",
  ...props
}: ModalOverlayProps) {
  return createPortal(
    <div className={className} {...props}>
      {children}
    </div>,
    document.body
  );
}
